import React, { useContext, useState } from 'react';
import 'src/components/shared/Agile/AgileBase.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Box from '@amzn/meridian/box';
import Toggle from '@amzn/meridian/toggle';
import Text from '@amzn/meridian/text';
import Row from '@amzn/meridian/row';
import Column from '@amzn/meridian/column';
import { useAppSelector } from '@store/hooks';
import { selectProgram } from '@store/slices/programSlice';
import AtAgileHeader from 'src/components/agile/agileComponents/AtAgileHeader';
import { AgileMacroplanogram } from '@components/agile/types/AgileMacroplanogramTypes';
import AtAssortmentSearchTable from '@components/agile/agileComponents/AtAssortmentSearchTable';
import Heading from '@amzn/meridian/heading';
import { useLocation } from 'react-router-dom';
import { LocationParams } from '@components/agile/AgileManagement';
import AgileURLParameterTypes from '@components/agile/types/AgileURLParameterTypes';
import AgileContext from '@components/agile/context/AgileContext';

export interface AssortmentSearchProps {
  urlParams: AgileURLParameterTypes;
  setUrlParameter: (value: AgileURLParameterTypes) => void;
}
const AssortmentSearch = (props: AssortmentSearchProps) => {
  const { urlParams, setUrlParameter } = props;
  const location = useLocation() as LocationParams;
  const [urlParameters] = useState<AgileURLParameterTypes>(location.state);
  const [includeFuture, setIncludeFuture] = useState<boolean>(false);
  const [zoneDetails, setZoneDetails] = useState<AgileMacroplanogram | undefined>(undefined);
  const [swapTime, setSwapTime] = useState<number>(0);
  const [includeDraft, setIncludeDraft] = useState(false);
  const programType = useAppSelector(selectProgram);
  const { enableZoneListInHeader, setEnableZoneListInHeader } = useContext(AgileContext);

  if (programType == null) {
    throw new Error('ProgramType is not initialized');
  }

  const setZoneDetailsAndTime = (zoneInfo: AgileMacroplanogram | undefined, timeStamp: number) => {
    setEnableZoneListInHeader(true);
    setZoneDetails(zoneInfo);
    setSwapTime(timeStamp);
  };

  return (
    <>
      <Box type="outline" spacingInset="300">
        <Column alignmentHorizontal="start">
          <Heading level={2}>Assortment Search Dashboard</Heading>
          <Row alignmentVertical="bottom">
            <AtAgileHeader
              setZoneDetailsAndTime={setZoneDetailsAndTime}
              urlParams={urlParameters ?? urlParams}
              setUrlParameter={setUrlParameter}
              enableZoneListInHeader={enableZoneListInHeader}
              includeDraft={includeDraft}
              setIncludeDraft={setIncludeDraft}
            />
            <Toggle checked={includeFuture} onChange={setIncludeFuture} size="large">
              <Text type="b400">Include Future Assortment</Text>
            </Toggle>
          </Row>
        </Column>
      </Box>
      {zoneDetails && swapTime ? (
        <AtAssortmentSearchTable
          zoneDetails={zoneDetails}
          swapTime={swapTime}
          includeFuture={includeFuture}
          includeDraft={includeDraft}
        />
      ) : null}
    </>
  );
};
export default AssortmentSearch;
